import { render } from "./GoogleSelect.vue?vue&type=template&id=af4637fe&scoped=true"
import script from "./GoogleSelect.vue?vue&type=script&lang=js"
export * from "./GoogleSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/pmattern/Documents/3 - GIT/studio-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-af4637fe"]])

export default __exports__